var common = require("../../utiles/common.js")

module.exports = {
    init: function () {
        common.fetch("/auth/mockLogin?userName=0xe693qvjske")
        var data = common.fetch("/auth/mobileToken/qrcodeValue").data;
        new QRCode(document.getElementById("qrcode"), JSON.stringify(data));
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/mToken/MToken.js
// module id = 25
// module chunks = 0